import React from 'react';
import { Row, Col, Descriptions } from 'antd';
import i18n from '../../../../i18n';

function formatCurrency(value) {
  if (value === null || value === undefined) {
    return '';
  }
  return Number(value).toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default function CostSummary({ deliveryCost, rePalletingCost, totalCost, loading }) {
  if (loading) {
    return <div>Расчёт...</div>;
  }

  if (totalCost === null || totalCost === undefined) {
    return null;
  }

  return (
    <Row gutter={[16, 24]} style={{ marginTop: '20px' }}>
      <Col lg={24} md={24} sm={24} sx={24}>
        <Descriptions
          title="Предварительная стоимость"
          column={1}
          bordered
          size="small"
        >
          <Descriptions.Item label="Доставка">
            {formatCurrency(deliveryCost)}
          </Descriptions.Item>
          <Descriptions.Item label="Перепалечивание">
            {formatCurrency(rePalletingCost)}
          </Descriptions.Item>
          <Descriptions.Item label="Итого">
            <strong>
              {formatCurrency(totalCost)}
            </strong>
          </Descriptions.Item>
        </Descriptions>
      </Col>
    </Row>
  );
}